export const environment = {
  appName: 'Solvente',
  favicon: 'assets/favicon-local.ico',
  production: false,
  keycloakAuthUrl: 'https://id-qa.solvente.stargate.is',
  keycloakRealm: 'solvente-sandbox',
  keycloakClientId: 'solvente-sandbox',
  backendServer: 'https://api-qa.solvente.stargate.is/api/v1',
  currentBuild: 'Prototype',
};
